export const triggerAddIfRequested = ({ setEditedSection, hasFiredRef, onAdd }) => {
  if (hasFiredRef.current) {
    return;
  }

  setEditedSection(prev => {
    if (prev?.isToAdd) {
      if (!hasFiredRef.current) {
        hasFiredRef.current = true;

        setTimeout(() => onAdd(), 0);
      }

      return { ...prev, isToAdd: false };
    }

    return prev;
  });
};
